import iconBook from "../assets/icon_book.svg";
import location from "../assets/Location.svg";
import reservationLogoImg from "../assets/icon_reserve.svg";
import Button from "./Button";
import { NavLink, useSearchParams } from "react-router-dom";

function ActiveBtns() {
  const [searchParams] = useSearchParams();
  const placeId = searchParams.get("place_id");
  return (
    <div>
      <div className='flex items-center gap-[10px] mb-[20px]'>
        <NavLink
          to={`/userLoyalty/menu?place_id=${placeId}`}
          className='flex items-center borderGray w-full gap-[5px] '
        >
          <div>
            <img
              src={iconBook}
              alt=''
              className=' bg-gray-100 p-[7px] rounded-full'
            />
          </div>{" "}
          <div>
            <p className='m-0 font-bold'>Меню</p>
          </div>
        </NavLink>
        <NavLink
          to={`/userLoyalty/reservation?place_id=${placeId}`}
          className='flex items-center borderGray w-full gap-[5px] '
        >
          <div>
            <img
              src={location}
              alt=''
              className=' bg-gray-100 p-[7px] rounded-full'
            />
          </div>{" "}
          <div>
            <p className='m-0 font-bold'>Забронировать</p>
          </div>
        </NavLink>
      </div>
      <div className='borderGray'>
        <div className='flex items-center  w-full gap-[5px] border-b-[1px] pb-[10px] mb-[10px] border-gray-200 '>
          <div>
            <img
              src={reservationLogoImg}
              alt=''
              className=' bg-gray-100 p-[7px] rounded-full'
            />
          </div>{" "}
          <div>
            <p className='m-0 font-bold'>Бронирования</p>
          </div>
        </div>
        <p className=' text-left w-[80%] mb-[10px]'>
          12.12.2025, 12:00, Летняя терраса №1, Гостей: 1, Продолжительность: 1
          ч. <span className='font-[600]'>Статус</span>:{" "}
          <span className='text-[#FAAD14] font-[600]'>
            Ожидает подтверждения
          </span>
        </p>
        <NavLink to={"/userLoyalty/userReservations"}>
          <Button>Все бронирования</Button>
        </NavLink>
      </div>
    </div>
  );
}

export default ActiveBtns;
